import { render, staticRenderFns } from "./credit-alert.vue?vue&type=template&id=f133900a&scoped=true&"
import script from "./credit-alert.vue?vue&type=script&lang=js&"
export * from "./credit-alert.vue?vue&type=script&lang=js&"
import style0 from "./credit-alert.vue?vue&type=style&index=0&id=f133900a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f133900a",
  null
  
)

export default component.exports